module.exports = __webpack_public_path__ + "img/bar-on.ecaf9b54.svg";